var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenericListButton',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.imgSrc,"title":_vm.label}})])
}
var staticRenderFns = []

export { render, staticRenderFns }